import { styled, alpha } from '@mui/material/styles';
import { buttonClasses } from '@mui/material/Button';
const createStyledToolbarButton = Component => styled(Component)(_ref => {
  let {
    theme: {
      palette,
      spacing
    }
  } = _ref;
  return {
    color: palette.text.secondary,
    minWidth: spacing(5),
    height: spacing(5),
    padding: 'unset',
    borderRadius: '50%',
    span: {
      margin: 'unset'
    },
    ["&.".concat(buttonClasses.root)]: {
      ':hover': {
        backgroundColor: alpha(palette === null || palette === void 0 ? void 0 : palette.text.secondary, palette.action.hoverOpacity)
      }
    }
  };
});
export default createStyledToolbarButton;